var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list_page_layout"},[_c('AppHeaderVue'),_vm._m(0),_c('AppFooter')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"privcyPolicy404"},[_c('h2',[_vm._v("404 "),_c('br'),_vm._v("Page not found")])])])
}]

export { render, staticRenderFns }